import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { contactAcharya } from "@/lib/identity/identity-api";

export function ContactAcharyaPage({ user, token }) {
  const [email, setEmail] = useState(user?.email || "");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await contactAcharya({
        message,
        email: token ? undefined : email,
        userId: user?.id,
        token,
      });
      setStatus(data.message || "Message sent.");
      setMessage("");
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen px-4 py-24 max-w-lg mx-auto" data-testid="contact-acharya-page">
      <Card>
        <CardHeader>
          <CardTitle className="font-heading">Contact Acharya</CardTitle>
          <p className="text-sm text-muted-foreground">
            Private message to the VedaPath team. We never display personal phone numbers or private
            email addresses.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            {!token && (
              <Input
                type="email"
                placeholder="Your email (required)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            )}
            <Textarea
              placeholder="Your message (min 10 characters)"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
              required
              minLength={10}
            />
            {error && <p className="text-sm text-destructive">{error}</p>}
            {status && <p className="text-sm text-muted-foreground">{status}</p>}
            <Button type="submit" disabled={loading} className="w-full">
              Send message
            </Button>
          </form>
          {!token && (
            <p className="text-xs text-muted-foreground mt-4">
              Signed-in users with verified email can track sādhana.{" "}
              <Link to="/login" className="text-primary">
                Sign in
              </Link>
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
